<section appFadeInOnScroll class="relative cursor-auto mx-md group rounded-md bg-cover bg-center bg-{{componentData.backgroundColor}} {{componentData.backgroundImageFit}} {{componentData.backgroundImagePosition}}" style="
    background-image: url({{componentData.enableBackgroundImage ? componentData.backgroundImageUrl : ''}});
    margin: {{componentData.enableSectionSpacing ? ( componentData.my + 'rem ' + componentData.mx + 'rem') : ''}};
" [ngClass]="{
    'mx-md my-md px-md py-md' : componentData.enableContainer,
    'hover:border border-dashed border-gray-500': editMode
}"
>
    @if(componentData.enableSectionSmooth){
        <div class="h-10 right-0 bg-gradient-to-t from-transparent to-bg_primary absolute top-0 w-full"></div>
    }
    @if(componentData.backgroundVideoUrl && componentData.enableBackgroundImage){
        <video #videoPlayer
               [autoplay]="true"
               [loop]="true"
               [muted]="true"
               playsinline
               class="absolute h-full top-0 left-0 w-full object-cover object-center">
            <source [src]="componentData.backgroundVideoUrl" type="video/mp4">
            Your browser does not support HTML5 video.
        </video>
    }
    @if(componentData.enableBackgroundMask){
        <div class="absolute inset-0 w-full h-full object-cover bg-bg_primary opacity-75"></div>
    }

    <div [ngClass]="{
          'w-full': !componentData.enableContainer,
          'container': componentData.enableContainer
         }"
         class="m-auto">

        @if(editMode){
            <div class="absolute bg-bg_primary p-3 z-20 rounded-md opacity-0 group-hover:opacity-100 transition-all duration-300 grid grid-cols-3 w-36 gap-4 top-2 right-2 text-normal">
                <a class="cursor-pointer" (click)="selectComponentForEdit()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25Z" fill="currentColor"/>
                        <path d="M20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z" fill="currentColor"/>
                    </svg>
                </a>
                <a class="cursor-pointer" (click)="deleteComponent(componentData.sortOrder)">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 6H5H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M19 6V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V6M10 6V4C10 2.9 10.9 2 12 2H14C15.1 2 16 2.9 16 4V6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10 11V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14 11V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </a>
                <a class="cursor-pointer" cdkDragHandle>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2L15 5H13V10H11V5H9L12 2Z" fill="currentColor"/>
                        <path d="M12 22L9 19H11V14H13V19H15L12 22Z" fill="currentColor"/>
                        <path d="M2 12L5 9V11H10V13H5V15L2 12Z" fill="currentColor"/>
                        <path d="M22 12L19 15V13H14V11H19V9L22 12Z" fill="currentColor"/>
                    </svg>

                </a>
            </div>
        }

        <div class="text-center" style="
            margin-bottom: {{componentData.enableSectionSpacing ? (componentData.py + 'rem') : ''}};">
            @if(componentData?.title){
                <h2 class="text-3xl font-extrabold py-4 mt-4  sm:text-4xl text-normal">
                    {{componentData.title | translate}}
                </h2>
            }
            @if(componentData?.subtitle) {
                <p class="text-lg text-normal py-3 mt-2">
                    {{componentData.subtitle | translate}}
                </p>
            }


        </div>
        <div class="z-10 relative">
            <ng-content></ng-content>
        </div>
    </div>
    @if(componentData.enableSectionSmooth){
        <div class="h-10 left-0 bg-gradient-to-b from-transparent to-bg_primary absolute bottom-0 w-full"></div>
    }
</section>